import React, { FC } from "react";
import { DashboardModes } from "shared/api";
import Title from "antd/es/typography/Title";
import classNames from "classnames";

interface LayoutOption {
  mode: DashboardModes;
  label: string;
  preview: React.ReactNode;
}

interface LayoutSelectorProps {
  title: string;
  selectedMode: DashboardModes;
  onSelectMode: (mode: DashboardModes) => void;
  options: LayoutOption[];
}

const LayoutSelector: FC<LayoutSelectorProps> = ({
  title,
  selectedMode,
  onSelectMode,
  options,
}) => {
  return (
    <>
      <Title level={5} className="mt-2">
        {title}
      </Title>

      <div className="grid grid-cols-3 gap-2 mb-2">
        {options.map((option) => {
          const isSelected = selectedMode === option.mode;
          return (
            <div
              key={option.mode}
              role="button"
              tabIndex={0}
              onClick={() => onSelectMode(option.mode)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  onSelectMode(option.mode);
                }
              }}
              className={classNames(
                "flex flex-col items-center justify-center p-2 rounded cursor-pointer border-2 transition-all",
                {
                  "border-blue-500 bg-blue-50": isSelected,
                  "border-gray-200 bg-gray-50 hover:border-gray-400":
                    !isSelected,
                }
              )}
            >
              <div className="w-full h-12 flex items-center justify-center mb-1">
                {option.preview}
              </div>
              <span
                className={classNames("text-xs text-center", {
                  "text-blue-600 font-semibold": isSelected,
                  "text-gray-600": !isSelected,
                })}
              >
                {option.label}
              </span>
            </div>
          );
        })}
      </div>
    </>
  );
};

export { LayoutSelector };
export type { LayoutOption };
